import { DEFAULT_MAX_AGE, DEFAULT_MIN_AGE } from '../campaign.constant';
import { CampaignFiltersDTO } from '../campaign.type';

const withoutDefaultAgeRange = (filters: CampaignFiltersDTO): CampaignFiltersDTO =>
  filters.minAge === DEFAULT_MIN_AGE && filters.maxAge === DEFAULT_MAX_AGE
    ? { ...filters, minAge: undefined, maxAge: undefined }
    : filters;

const withoutEmptyCollections = (filters: CampaignFiltersDTO): CampaignFiltersDTO => ({
  ...filters,
  clientsAcquiredFrom: filters.clientsAcquiredFrom?.length ? filters.clientsAcquiredFrom : undefined,
  clientsTypes: filters.clientsTypes?.length ? filters.clientsTypes : undefined,
  crmFieldFilters: filters.crmFieldFilters?.filter(
    crmFieldFilter => crmFieldFilter.fieldId && crmFieldFilter.values.length > 0,
  ),
  consumedProductIds: filters.consumedProductIds?.length ? filters.consumedProductIds : undefined,
  fromConnector: filters.fromConnector || undefined,
});

// The visit period doubles as the window the product criterion is evaluated over, so a
// campaign stored back when the two were separate realigns instead of keeping a stale one.
const withConsumptionPeriodFromPassage = (filters: CampaignFiltersDTO): CampaignFiltersDTO =>
  filters.consumedProductIds?.length
    ? {
        ...filters,
        startConsumptionDate: filters.startPassageDate,
        endConsumptionDate: filters.endPassageDate,
      }
    : {
        ...filters,
        consumedProductsMatch: undefined,
        startConsumptionDate: undefined,
        endConsumptionDate: undefined,
        minConsumedQuantity: undefined,
      };

export const toApiCampaignFilters = (filters: CampaignFiltersDTO): CampaignFiltersDTO => {
  if (filters.clientIds?.length) {
    return {
      storeIds: filters.storeIds,
      clientIds: filters.clientIds,
      zipOrPostcodes: [],
      radius: null,
      originProviderId: null,
    };
  }
  const { clientIds: _unused, ...rest } = withConsumptionPeriodFromPassage(
    withoutEmptyCollections(withoutDefaultAgeRange(filters)),
  );
  return rest;
};
